import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/StarHalf.tsx
import React from "react";
var SvgStarHalf, StarHalf_default;
var init_StarHalf = __esm({
  "src/icons/StarHalf.tsx"() {
    SvgStarHalf = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "m12 15.968 4.247 2.377-.949-4.773 3.573-3.305-4.833-.573L12 5.275v10.693Zm0 2.292-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26Z"
        }
      )
    );
    StarHalf_default = SvgStarHalf;
  }
});

export {
  StarHalf_default,
  init_StarHalf
};
